<script>
  import IconClose from '@/components/atoms/IconClose'
  import IconTweet from '@/components/atoms/IconTweet'
  import { zeroPadding } from '@/mixins/common'

  export default {
    name: 'ModalCheckPoint',
    components: {
      IconClose,
      IconTweet
    },
    data() {
      return {
        items: [
          {
            message: 'はじめての回答おめでとうございます！\n残り19問、楽しんで進めていきましょう！',
            shareText: 'おめでとう！ #日めくりクエスチョン で、 #スタンプ1個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q1/`,
          },
          {
            message: '2問達成！明日も頑張って！\nあなたのVitalityライフをもっと聞かせてください！',
            shareText: 'いい感じ！ #日めくりクエスチョン で、 #スタンプ2個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q2/`,
          },
          {
            message: '3問達成！いい調子ですね！\n住友生命「Vitality」をもっと楽しんでいきましょう！',
            shareText: '素晴らしい！ #日めくりクエスチョン で、 #スタンプ3個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q3/`,
          },
          {
            message: '5問達成はさすが！\nこの調子で最後まで駆けぬけよう！',
            shareText: 'さすが！ #日めくりクエスチョン で、 #スタンプ5個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q5/`,
          },
          {
            message: 'すごい！10問達成で、折り返し地点です！\n楽しく無理せず続けていきましょう！',
            shareText: 'すごい！折り返し地点に到達！ #日めくりクエスチョン で、 #スタンプ10個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q10/`,
          },
          {
            message: '15問達成、残りあと少しです！！\nラストスパートも楽しみましょう！',
            shareText: 'ラストスパートも楽しもう！ #日めくりクエスチョン で、 #スタンプ15個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q15/`,
          },
          {
            message: '20問達成おめでとう！！！あなたはもう\n住友生命「Vitality」を楽しむ達人ですね！',
            shareText: 'おめでとう！あなたはもう住友生命「Vitality」を楽しむ達人ですね！ #日めくりクエスチョン で、 #スタンプ20個獲得 しました！',
            ogpUrl: `${process.env.VUE_APP_PATH}share_q20/`,
          }
        ],
      }
    },
    computed: {
      id() {
        return this.$store.state.checkpointId;
      },
      getSrc() {
        return require(`@/assets/img/modal_illust${zeroPadding(this.id + 1, 2)}.png`);
      },
      getMessage() {
        return this.items[this.id].message;
      },
      classnamesBg() {
        const getColorId = () => {
          switch (this.id) {
            case 0:
            case 2:
            case 5:
            default:
              return 'color01';
            case 1:
            case 4:
              return 'color02';
            case 3:
            case 6:
              return 'color03';
          }
        }
        return getColorId()
      }
    },
    methods: {
      close() {
        this.$store.commit('closeModalCheckpoint', false);
      },
      getUrl() {
        let comment = `${this.items[this.id].shareText} #住友生命Vitality`;
        return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.items[this.id].ogpUrl)}&text=${encodeURIComponent(comment)}`;
      }
    }
  }
</script>

<template lang="pug">
  transition(
    name = 'modal-checkpoint'
    )
    .modal-checkpoint(
      v-show = '$store.state.isShownModalCheckpoint === true'
      )
      .modal-checkpoint__body-wrap
        .modal-checkpoint__body
          .modal-checkpoint__body-in
            .modal-checkpoint__content
              img.modal-checkpoint__heading(
                src = '~@/assets/img/modal_ribbon_share.png'
                alt = 'おめでとう！'
                )
              img.modal-checkpoint__illust(
                :src = 'getSrc'
                )
              .modal-checkpoint__message
                |{{ getMessage }}
              a.modal-checkpoint__tweet(
                :href = 'getUrl()'
                target = '_blank'
                )
                IconTweet.modal-checkpoint__tweet-icon
                |達成をシェア
              .modal-checkpoint__close(
                @click = 'close'
                )
                IconClose(
                  color = '#0000000'
                  )
          .modal-checkpoint__body-bg(
            :class = 'classnamesBg'
            )
      .modal-checkpoint__bg(
        @click = 'close'
        )
</template>

<style lang="scss">
  .modal-checkpoint {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    transform: translate3d(0, 0, 0);
    &__body-wrap {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
      @include l-more-than-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__body {
      box-sizing: border-box;
      overflow: hidden;
      border-radius: 8px;
      margin: auto;
      z-index: 1;
      @include l-more-than-mobile {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 550px;
        width: 520px;
      }
      @include l-mobile {
        position: relative;
        width: 100%;
        max-width: 335px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    &__body-in {
      height: 100%;
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      border-radius: 8px;
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 1;
      padding-top: 11px;
      padding-bottom: 11px;
    }
    &__heading {
      width: 260px;
      height: 90px;
      display: block;
    }
    &__illust {
      width: 295px;
      height: 295px;
      display: block;
      margin-top: -10px;
    }
    &__message {
      line-height: (22 / 15);
      white-space: pre-wrap;
      @include fontSize(15);
      text-align: center;
      padding-left: 15px;
      padding-right: 15px;
      margin-bottom: 15px;
    }
    &__tweet {
      width: 275px;
      height: 55px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 28px;
      color: #fff;
      @include fontSize(18);
      font-weight: 700;
      text-decoration: none;
      background-color: $color-twitter;
    }
    &__tweet-icon {
      margin-right: 10px;
    }
    &__close {
      width: 44px;
      height: 44px;
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 4px;
      right: 4px;
    }
    @keyframes rotateModalBodyBg {
      0% {
        transform: rotate(0deg)
      }
      100% {
        transform: rotate(360deg)
      }
    }
    &__body-bg {
      width: (520 * 1.44) * 1px;
      height: (520 * 1.44) * 1px;
      position: absolute;
      top: calc(50% - 260px * 1.44);
      left: calc(50% - 260px * 1.44);
      background-size: 100% 100%;
      animation-name: rotateModalBodyBg;
      animation-timing-function: linear;
      animation-duration: 10s;
      animation-iteration-count: infinite;
      &.color01 {
        background-image: url('~@/assets/img/modal_bg_yellowline.png');
      }
      &.color02 {
        background-image: url('~@/assets/img/modal_bg_pinkline.png');
      }
      &.color03 {
        background-image: url('~@/assets/img/modal_bg_goldline.png');
      }
    }
    &__bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
    }

    //
    // 表示・非表示アニメーション
    &.modal-checkpoint-enter-to {
      transition-duration: 0.2s;
    }
    &.modal-checkpoint-leave-to {
      transition-duration: 0.23s;
    }

    &__body {
      .modal-checkpoint-enter & {
        opacity: 0;
        transform: scale(0.9);
      }
      .modal-checkpoint-enter-to & {
        opacity: 1;
        transform: scale(1);
        transition-duration: 0.2s;
        transition-property: opacity, transform;
        transition-timing-function: $easeOutQuad;
      }
      .modal-checkpoint-leave-to & {
        opacity: 0;
        transform: scale(0.9);
        transition-duration: 0.23s;
        transition-property: opacity, transform;
        transition-timing-function: $easeInQuad;
      }
    }

    &__bg {
      .modal-checkpoint-enter & {
        opacity: 0;
      }
      .modal-checkpoint-enter-to & {
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: opacity;
      }
      .modal-checkpoint-leave-to & {
        opacity: 0;
        transition-duration: 0.23s;
        transition-property: opacity;
      }
    }
  }
</style>
